<section class="zag-bulk-edit-job-details-dialog">
  <header class="zag-bulk-edit-job-details-dialog__header">
    <div class="zag-bulk-edit-job-details-dialog__heading">
      <h2 class="zag-bulk-edit-job-details-dialog__title" [id]="titleId">
        <span class="zag-bulk-edit-job-details-dialog__job-title">{{ 'bulkEdit.inline.jobTitle' | translate }}</span>
        @if (data.job.propertyLabelKey; as propertyLabelKey) {
          <span class="zag-bulk-edit-job-details-dialog__property-title">{{ propertyLabelKey | translate }}</span>
        }
      </h2>
      <p class="zag-bulk-edit-job-details-dialog__description" [id]="descriptionId">
        {{ 'bulkEdit.selectedEntities' | translate: { count: data.rehydration.total } }}
      </p>
    </div>

    <button
      zagButton="basic"
      zagType="secondary"
      zagSize="sm"
      type="button"
      class="zag-bulk-edit-job-details-dialog__close"
      [attr.aria-label]="'common.close' | translate"
      (click)="close()"
    >
      <span zagIcon="close" aria-hidden="true"></span>
    </button>
  </header>

  <div class="zag-bulk-edit-job-details-dialog__status" role="status" [attr.data-status]="terminalStatus()">
    <span [zagIcon]="statusIcon()" aria-hidden="true"></span>
    <span>{{ statusLabelKey() | translate }}</span>
  </div>

  <div class="zag-bulk-edit-job-details-dialog__summary">
    @if (data.rehydration.job.totals; as totals) {
      <dl class="zag-bulk-edit-job-details-dialog__metrics" role="group" [attr.aria-label]="'bulkEdit.applySuccess' | translate: totals">
        @for (metric of totalMetrics; track metric.key) {
          <div class="zag-bulk-edit-job-details-dialog__metric">
            <dt>{{ metric.labelKey | translate }}</dt>
            <dd>{{ totals[metric.key] }}</dd>
          </div>
        }
      </dl>
    }

    @if (data.rehydration.job.bucketsSummary; as buckets) {
      <dl class="zag-bulk-edit-job-details-dialog__metrics" role="group" [attr.aria-label]="'bulkEdit.step2Title' | translate">
        @for (metric of bucketMetrics; track metric.key) {
          <div class="zag-bulk-edit-job-details-dialog__metric">
            <dt>{{ metric.labelKey | translate }}</dt>
            <dd>{{ buckets[metric.key] }}</dd>
          </div>
        }
      </dl>
    }
  </div>

  <div class="zag-bulk-edit-job-details-dialog__results">
    <zag-bulk-edit-job-result-list
      [results]="data.rehydration.results"
      [entityNameResolver]="data.entityNameResolver"
      [entityResolver]="data.entityResolver"
      [rowTemplate]="data.resultRowTemplate"
    />
  </div>

  <footer class="zag-bulk-edit-job-details-dialog__footer">
    <button zagButton="outlined" zagType="secondary" type="button" (click)="close()">
      {{ 'common.close' | translate }}
    </button>
  </footer>
</section>
